import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";

export class RemoveResourceCommand extends CommandBase {
    id: string;

    constructor(id: string) {
        super();
        this.id = id;
    }

    execute(data: RemoteConstantsModel): boolean {
        const index = data.resources.findIndex(u => u.id === this.id);
        if (index < 0) {
            return false;
        }

        data.resources.splice(index, 1);
        for (const key in data.localization) {
            delete data.localization[key][this.id];
        }

        return true;
    }
}